import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import Login from './Pages/Login';
import PagoExpress from "./Pages/PagoExpress";
import Signup from "./Pages/Signup";
import CodeVerification from "./Pages/CodeVerification";
import Inicio from "./Pages/Inicio";
import MyBills from "./Components/MyBills";
import MyConsumption from "./Components/MyConsumption";
import PaymentHistory from "./Components/PaymentHistory";
import Agreements from "./Components/Agreements";

function App() {
    return (
        <BrowserRouter>
            <Routes>
                <Route path="/login" element={<Login />} />
                <Route path="/signup" element={<Signup />} />
                <Route path="/verification" element={<CodeVerification />} />
                <Route path="/pago-express/:aid" element={<PagoExpress />} />
                <Route path="/inicio" element={<Inicio />}>
                    <Route index element={<Navigate to="boletas" replace />} />
                    <Route path="boletas" element={<MyBills />} />
                    <Route path="consumos" element={<MyConsumption />} />
                    <Route path="pagos" element={<PaymentHistory />} />
                    <Route path="convenios" element={<Agreements />} />
                </Route>
                <Route path="*" element={<Navigate to="/login" replace />} />
            </Routes>
        </BrowserRouter>
    );
}

export default App;
